export default __webpack_public_path__ + "static/media/forestly-expl-03_DE.b9f57907.png";